import { useState } from "react";
import { IoFileTrayOutline, IoSettingsOutline } from "react-icons/io5";
import AccountCharts from "./components/AccountCharts";

const items = [
  {
    name: "Account Charts",
    description: "Configure chart of accounts",
    icon: <IoFileTrayOutline className="text-lg text-gray-400" />,
    content: <AccountCharts />,
  },
];

const Settings = () => {
  const [selected, setSelected] = useState(items[0]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-0">
      <div className="grid grid-cols-4 gap-5">
        <div className="col-span-4 lg:col-span-1">
          <div className="card p-0">
            <div className="flex justify-between items-center m-3">
              <p className="text-sm text-gray-400">Settings</p>
              <IoSettingsOutline className="text-gray-400" />
            </div>
            {items.map((item, index) => (
              <div
                key={index}
                className="group cursor-pointer border-t hover:bg-gray-50"
                onClick={() => setSelected(item)}
              >
                <div
                  className={`flex items-center px-4 py-3 ${
                    item === selected && `border-blue-400 border-r-4`
                  }`}
                >
                  {item.icon}
                  <div className="ml-5">
                    <p className="text-gray-500 text-sm group-hover:text-gray-500">
                      {item.name}
                    </p>
                    <span className="text-gray-400 text-xs">
                      {item.description}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-span-4 lg:col-span-3">{selected.content}</div>
      </div>
    </div>
  );
};

export default Settings;
